export const LD_CLIENT_ID = import.meta.env.REACT_APP_LD_CLIENT_ID;
